import { Component } from "react";

import MGAlertModal from "../../components/MGAlertModal/MGAlertModal"
import MGWarning from "../../components/MGWarning/MGWarning"
import PaymentDescription from "./PaymentDescription/PaymentDescription"
import TermsConditions from "./TermsConditions/TermsConditions";
import PaymentConfirmation from "./PaymentConfirmation/PaymentConfirmation"
import { getLOGOUT } from "../../env";

// Images
import warning from "../../images/warning.svg"
import warning_error from "../../images/warning_error.svg"
import warning_success from "../../images/warning_success.svg"
import "./Quotas.css"

export default class Quotas extends Component {
    constructor(props) {
        super(props)
        this.state = {
            step: 0,
            error: [],
            loaded: false
        };
    }

    loadWarning() {
        return (<MGWarning
            icon={warning}
            title="Quotas em atraso."
            msg={`Para usufruir de todas as vantagens de ser Associado, é fundamental ter
                as quotizações em dia.`}
            primaryButton="Regularizar quotas"
            secondButton="Logout"
            primaryButtonClick={() => { this.setState({ step: 1 }) }}
            secondButtonClick={() => { this.logout() }}
            secondaryText={"Se necessitar de apoio ou esclarecimento adicional, "}
            linkText={"contacte-nos."}
            clickLink={() => {
                document.getElementById("popupGestorTrigger").click();
            }}
        />);
    }

    loadDescription() {
        return (
            <PaymentDescription
                clickLink={() => {
                    document.getElementById("popupGestorTrigger").click();
                }}
                primaryButtonClick={() => { this.setState({ step: 2 }) }}
                secondButtonClick={() => { this.setState({ step: 0 }) }} />
        );
    }

    loadTermsConditions() {
        return (
            <TermsConditions clickBack={() => { this.setState({ step: 1 }) }} clickContinue={() => { this.setState({ step: 3 }) }} />
        );

    }

    loadPaymentConfirmation() {
        return (<PaymentConfirmation clickBack={() => { this.setState({ step: 2 }) }} clickContinue={() => { this.setState({ step: 4 }) }} />);
    }

    loadSuccess() {
        return (<MGWarning
            icon={warning_success}
            title="Sucesso!"
            msg={`O pedido de pagamento das quotizações em atraso foi realizado com sucesso.
A regularização poderá demorar ... `}
            secondButton="Logout"
            secondButtonClick={() => { this.logout() }}
            secondaryText={"Se necessitar de apoio ou esclarecimento adicional, "}
            linkText={"contacte-nos."}
            clickLink={() => {
                document.getElementById("popupGestorTrigger").click();
            }}
        />);
    }

    loadFail() {
        return (<MGWarning
            icon={warning_error}
            title="Ocorreu um erro!"
            msg={`Contacte o seu gestor ou a linha de Apoio ao Associado para mais informações.`}
            primaryButton="Tentar Novamente"
            secondButton="Logout"
            primaryButtonClick={() => { this.setState({ step: 0 }) }}
            secondButtonClick={() => { this.logout() }} // TODO: Substituir pelo logout 
            secondaryText={"Se necessitar de apoio ou esclarecimento adicional, "}
            linkText={"contacte-nos."}
            clickLink={() => {
                document.getElementById("popupGestorTrigger").click();
            }}
        />);
    }

    logout() {
        window.sessionStorage.setItem("showedElectionPopup", "false");

        const { msalInstance } = this.context;
        if (msalInstance) {
            msalInstance.logoutRedirect({
                postLogoutRedirectUri: getLOGOUT(),
                idTokenHint: this.context.idToken,
            });
        }
    }

    contactUs() {
        document.getElementById("popupGestorTrigger").click();
    }

    render() {
        let content

        switch (this.state.step) {
            case 0:
                content = this.loadWarning();
                break;

            case 1:
                content = this.loadDescription();
                break;

            case 2:
                content = this.loadTermsConditions();
                break;

            case 3:
                content = this.loadPaymentConfirmation();
                break;

            case 4:
                content = this.state.error ? this.loadSuccess() : this.loadFail()
                break;
            default:
                content = this.contactUs();
                break;

        }
        return (
            <MGAlertModal
                content={content}
            />
        );
    }
}